import React from "react";
import SEOHead from "../../components/SEOHead";
import Formulaire from "./Formulaire";
import AppelAction from "../../components/AppelAction";

const Contact = () => {
  return (
    <>
      <SEOHead />
      <Formulaire />
      <AppelAction className="section-border-top" />
    </>
  );
};

export default Contact;
